import React, { useEffect, useState, useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CustomCursor = () => {
  const [hovering, setHovering] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 350, damping: 28, mass: 0.5 });
  const ringY = useSpring(y, { stiffness: 350, damping: 28, mass: 0.5 });

  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) {
      setEnabled(true);
      document.body.classList.add("hide-native-cursor");
    }
    return () => document.body.classList.remove("hide-native-cursor");
  }, []);

  useEffect(() => {
    if (!enabled) return;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = e.target;
      const interactive = el.closest("a, button, [data-cursor='hover'], input, textarea");
      setHovering(!!interactive);
    };
    const leave = () => setHidden(true);
    const enter = () => setHidden(false);
    window.addEventListener("mousemove", move);
    document.addEventListener("mouseleave", leave);
    document.addEventListener("mouseenter", enter);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseleave", leave);
      document.removeEventListener("mouseenter", enter);
    };
  }, [enabled, x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="fixed top-0 left-0 z-[100] pointer-events-none rounded-full"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
        animate={{ width: hovering ? 8 : 6, height: hovering ? 8 : 6, opacity: hidden ? 0 : 1, backgroundColor: hovering ? "#FF6A00" : "#ffffff" }}
        transition={{ duration: 0.15 }}
      />
      <motion.div
        className="fixed top-0 left-0 z-[100] pointer-events-none rounded-full border"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
        animate={{
          width: hovering ? 56 : 30,
          height: hovering ? 56 : 30,
          opacity: hidden ? 0 : hovering ? 1 : 0.5,
          borderColor: hovering ? "rgba(255,106,0,0.7)" : "rgba(255,255,255,0.5)",
          backgroundColor: hovering ? "rgba(255,106,0,0.08)" : "rgba(255,255,255,0)",
        }}
        transition={{ duration: 0.2 }}
      />
    </>
  );
};
